<template>
  <div id="footer" class="footer">
    <div class="section size-30">

      <div class="footer-copy">
        <a class="underline" href="/about/">© 2019 ООО «‎Джаст Резерв»</a>
      </div>
      <div class="footer-sign">
        <a href="https://app.justreserve.me" class="button primary">
          <div class="text">
            Войти
          </div>
        </a>
        <a href="/signup" class="button">
          <div class="text">
            Регистрация
          </div>
        </a>
      </div>
      <div class="footer-jrminfo">
        Минск, Беларусь
        <br>
        Улица Шаранговича, 67
        <br>
        <br>
        УНП: 192954057
        <br>
        <br>
        <a class="underline" href="mailto:info@justreserve.me">info@justreserve.me</a>
      </div>
      <div class="footer-links">
        <a class="underline" href="/legal/terms">Cоглашение</a>
        <br><br>
        <a class="underline" href="/legal/license">Договор</a>
        <br><br>
        <a class="underline" href="/legal/privacy">Приватность</a>
        <br><br>
        <a class="underline" href="/legal/cookies">Cookies</a>
      </div>

      <div class="payment-systems">
        <img style="width:100%;" src="/img/payments2.png">
      </div>

    </div>
    <div class="section size-14">
      <div class="footer-linklist">
        <div class="footer-ll-h">
          <a href="/about">Компания</a>
        </div>
        <div class="footer-ll-l">
          <a href="/about">О Джаст Резерв</a>
          <a href="/about#dreamteam">Команда</a>
          <a href="/about#sales">Отдел продаж</a>
          <a href="/about#partners">Партнёры</a>
          <a href="/about#contacts">Контакты</a>
          <a href="/legal">Юридические<br>вопросы</a>
          <a href="/about#toinvestors">Инвесторам</a>
        </div>
      </div>
    </div>
    <div class="section size-14">
      <div class="footer-linklist">
        <div class="footer-ll-h">
          <a href="/platform/">Платформа</a>
        </div>
        <div class="footer-ll-l">
          <a href="/platform#dashboard">Статистика и <br>анализ</a>
          <a href="#">Cloud Platform</a>
          <a href="/platform#pos">POS</a>
          <a href="/platform#storehouse">Склад</a>
          <a href="/platform#kitchen">Кухня</a>
          <a href="/platform#menu">Меню</a>
          <a href="/platform#issuance">Выдача заказов</a>
        </div>
      </div>
    </div>

    <div class="section size-14">
      <div class="footer-linklist">
        <div class="footer-ll-h">
          <a href="/pricing/">Цены</a>
        </div>
        <div class="footer-ll-l">
          <a href="/pricing">Тарифные планы</a>
          <a href="/pricing">Дополнительные<br>услуги</a>
          <a href="/pricing#dev">Разработка ПО</a>
          <a href="/pricing#paas">White Label</a>
          <a href="/pricing#paas">PaaS</a>
        </div>
      </div>
    </div>

    <div class="section size-14">
      <div class="footer-linklist">
        <div class="footer-ll-h">
          <a href="/api/">API</a>
        </div>
        <div class="footer-ll-l">
          <a href="mailto:artemnaumov@justreserve.me">Идеи и предложения</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TheFooter',
  methods: {
    scrollToTop() {
      document.body.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
}
</script>
